import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The volunteer of the DDDTW community. At keep following the Development of various architectures and technologies. With a deep understanding of the essence of technology serving business, I have gradually paid attention to the business value of the software itself in recent years.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      